module.exports = __webpack_public_path__ + "static/img/birou.f33cf36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/birou.jpg
// module id = OqWO
// module chunks = 0